import {Component, Input, OnInit} from '@angular/core';
import {QuestionComponent} from '../question.component';
import {QuestionBase} from '../../domain/question.base';
import {AddressLookupService} from '../address-lookup.service';

@Component({
  selector: `crds-freeform-address-question`,
  template: `
    <div>
      <crds-google-places [question]="question" [form]="form" [mapsConfig]="question.mapsConfig"></crds-google-places>
    </div>`,
  styles: [
    `
      .selected-address {
        font-size: 0.75rem;
      }
    `
  ]
})
export class FreeformAddressQuestionComponent extends QuestionComponent {
  @Input() form;
  @Input() question: QuestionBase<any>;

  constructor() {
    super();
  }
}
